<?xml version="1.0" encoding="UTF-8"?>
<svg width="13px" height="12px" viewBox="0 0 13 12" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path d="M8,-1 L8,4.5 L13.5,4.5 L13.5,7.5 L8,7.5 L8,13 L5,13 L5,7.5 L-0.5,7.5 L-0.5,4.5 L5,4.5 L5,-1 L8,-1 Z" id="Combined-Shape" fill="#FFFFFF" transform="translate(6.500000, 6.000000) rotate(-315.000000) translate(-6.500000, -6.000000) "></path>
    </g>
</svg>